<div class="modal fade" id="{{modalId}}" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div *ngIf="pageLoading1" class="loader text-center">
				<img src="../../assets/img/loading.gif" />
				<p style="color: black;font-weight: bolder;">Loading...</p>
			</div>
			<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
				<div class="modal-header text-center row g-1">
					<h4 class="modal-title mb-0 col-11 text-start">
						<strong>
							{{uId ? "Edit Roster" : "Add Roster"}}
						</strong>
					</h4>
					<div class="col-1 text-end">
						<button type="button" class="btn-close" (click)="clearForm();"></button>
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<div class="row mb-3">
								<div class="col-5">
									<div class="ng-select-material">
										<ng-select [items]="userList" bindValue="emp_code" bindLabel="full_name"
											[clearable]="true" placeholder="Employee*" formControlName="emp_code"
											id="emp_code_rstr" appearance="outline"
											[ngClass]="{'is-invalid':showError('emp_code')}">
										</ng-select>
									</div>
									<p *ngIf="showError('emp_code')" class="text-danger">
										<span *ngIf="f.emp_code.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-1">
									@if(f.emp_code.value && !uId){
									<button type="button" class="btn btn-sm btn-success mt-2" (click)="fetchForCopy()"
										matTooltip="Copy Previous">
										@if(fetchForCopyLoader){
										<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas','copy']"></fa-icon>
										}
									</button>
									}
								</div>
								<div class="col-3">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control"
												[ngClass]="{'is-invalid':showError('from_date')}" placeholder=""
												formControlName="from_date" ngbDatepicker id="from_date_rstr"
												#from_date="ngbDatepicker" [minDate]="minDate" [container]="'body'"
												[markDisabled]="fromDateDisabled" />
											<label>From(Monday)*</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="from_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('from_date')" class="text-danger">
										<span *ngIf="f.from_date.errors?.required">
											Required
										</span>
										<span *ngIf="f.from_date.errors?.ngbDate">
											Invalid
										</span>
									</p>
									<p *ngIf="moduleForm.errors" class="text-danger">
										<span *ngIf="moduleForm.errors?.invalidFromDate">
											Invalid
										</span>
									</p>
								</div>
								<div class="col-3">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control" [ngClass]="{'is-invalid':showError('to_date')}"
												placeholder="YYYY-MM-DD" formControlName="to_date" ngbDatepicker
												id="to_date_rstr" #to_date="ngbDatepicker" [minDate]="minDate"
												[container]="'body'" />
											<label>To(Sunday)*</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="to_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('to_date')" class="text-danger">
										<span *ngIf="f.to_date.errors?.required">
											Required
										</span>
										<span *ngIf="f.to_date.errors?.ngbDate">
											Invalid
										</span>
									</p>
									<p *ngIf="moduleForm.errors" class="text-danger">
										<span *ngIf="moduleForm.errors?.invalidToDate">
											Invalid
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<table class="table table-bordered">
										<thead>
											<tr>
												<th style="width: 45%;">
													In Date Time
													<span style="color: #b40a09;">*&nbsp;</span>
												</th>
												<th style="width: 45%;">
													Out Date Time
													<span style="color: #b40a09;">*&nbsp;</span>
												</th>
												<th style="width: 10%;">
													<button type="button" (click)="addRow()"
														class="btn btn-xs btn-primary">
														<fa-icon [icon]="['fas', 'plus']"></fa-icon>
														Add
													</button>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr formArrayName="line_items"
												*ngFor="let creds of get_rows.controls; let i = index">
												<ng-container [formGroupName]="i">
													<td>
														<div class="w-50 float-start">
															<div class="input-group">
																<input class="form-control"
																	[ngClass]="{'is-invalid':showError2(i,'in_date')}"
																	placeholder="YYYY-MM-DD" formControlName="in_date"
																	ngbDatepicker id="in_date_rstr"
																	#in_date="ngbDatepicker" [minDate]="minDateInRow"
																	[maxDate]="maxDateInRow" [container]="'body'" />
																<button class="btn btn-outline-secondary"
																	(click)="in_date.toggle()" type="button">
																	<fa-icon
																		[icon]="['fas', 'calendar-week']"></fa-icon>
																</button>
															</div>
															<p *ngIf="showError2(i,'in_date')" class="text-danger">
																<span *ngIf="creds.get('in_date')?.errors?.required">
																	Required
																</span>
																<span *ngIf="creds.get('in_date')?.errors?.ngbDate">
																	Invalid
																</span>
																<span *ngIf="creds.get('in_date')?.errors?.leave">
																	On leave
																</span>
															</p>
														</div>
														<div class="w-50 float-start ps-1">
															<div>
																<ngb-timepicker formControlName="in_time" [hourStep]="1"
																	[minuteStep]="1" [meridian]="false"
																	[spinners]="false"></ngb-timepicker>
															</div>
															<p *ngIf="showError2(i,'in_time')" class="text-danger">
																<span *ngIf="creds.get('in_time')?.errors?.required">
																	Required
																</span>
															</p>
														</div>
													</td>
													<td>
														<div class="w-50 float-start">
															<div class="input-group">
																<input class="form-control"
																	[ngClass]="{'is-invalid':showError2(i,'out_date')}"
																	placeholder="YYYY-MM-DD" formControlName="out_date"
																	ngbDatepicker id="out_date_rstr"
																	#out_date="ngbDatepicker" [minDate]="minDateInRow"
																	[maxDate]="maxDateInRow" [container]="'body'" />
																<button class="btn btn-outline-secondary"
																	(click)="out_date.toggle()" type="button">
																	<fa-icon
																		[icon]="['fas', 'calendar-week']"></fa-icon>
																</button>
															</div>
															<p *ngIf="showError2(i,'out_date')" class="text-danger">
																<span *ngIf="creds.get('out_date')?.errors?.required">
																	Required
																</span>
																<span *ngIf="creds.get('out_date')?.errors?.ngbDate">
																	Invalid
																</span>
															</p>
														</div>
														<div class="w-50 float-start ps-1">
															<div>
																<ngb-timepicker formControlName="out_time"
																	[hourStep]="1" [minuteStep]="1" [meridian]="false"
																	[spinners]="false"></ngb-timepicker>
															</div>
															<p *ngIf="showError2(i,'out_time')" class="text-danger">
																<span *ngIf="creds.get('out_time')?.errors?.required">
																	Required
																</span>
															</p>
														</div>
													</td>
													<td>
														<button type="button" (click)="deleteRow(i)"
															class="btn btn-xs btn-danger" matTooltip="Remove">
															<fa-icon [icon]="['fas', 'times']"></fa-icon>
														</button>
													</td>
												</ng-container>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success me-1">
						<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						Submit
					</button>
					<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
				</div>
			</form>
		</div>
	</div>
</div>